import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar";
import ExtrasModal from "./components/ExtrasModal";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Sweets from "./pages/Sweets";
import Catering from "./pages/Catering";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Rewards from "./pages/Rewards";
import Auth from "./pages/Auth";
import OrderSuccess from "./pages/OrderSuccess";
import Admin from "./pages/Admin";

function App() {
  return (
    <div className="App min-h-screen bg-[#fdf8f1]">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/sweets" element={<Sweets />} />
              <Route path="/catering" element={<Catering />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/rewards" element={<Rewards />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/order-success" element={<OrderSuccess />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <ExtrasModal />
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
